import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    timerIntervalSeconds: { type: Number, default: 15 }
  }

  connect() {
    this.time = new Date(Date.parse(this.element.getAttribute("datetime"))).getTime()
    this.#update()
    this.#startTimer()
  }

  disconnect() {
    if (!this.timer) { return }

    clearInterval(this.timer)
  }

  #update() {
    this.element.innerHTML = this.#toTimeElapsedString()
  }

  #startTimer() {
    if (!this.timer) {
      this.timer = setInterval(() => { this.#update() }, this.timerIntervalSecondsValue * 1000)
    }
  }

  #toTimeElapsedString() {
    const ms = new Date().getTime() - this.time
    const seconds = Math.floor(ms / 1000)
    const minutes = Math.floor(seconds / 60)

    if (ms < 0) {
      return ""
    } else if (seconds < 60) {
      return seconds + window.I18n.time_ago.seconds_indicator
    } else {
      return minutes + window.I18n.time_ago.minutes_indicator
    }
  }
}
